module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel grid",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "carousel--root"
  }, [_c('div', {
    staticClass: "carousel--row grid--row"
  }, [_c('div', {
    staticClass: "carousel--wrap",
    style: (_vm.wrapStyles)
  }, _vm._l((_vm.items), function(item, itemIdx) {
    return _c('div', {
      ref: "item",
      refInFor: true,
      staticClass: "carousel--item grid--col",
      style: (_vm.itemStyles)
    }, [_vm._t("item", null, {
      item: item,
      isActive: _vm.isActive(itemIdx),
      itemIdx: itemIdx
    })], 2)
  }))])]), _vm._v(" "), (_vm.showArrowsElement) ? _c('div', {
    staticClass: "carousel--arrows"
  }, [_c('button', {
    staticClass: "carousel--arrow carousel--arrow__prev",
    attrs: {
      "type": "button",
      "disabled": _vm.state.idx - 1 < 0 ? true : null
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeIndex(_vm.state.idx - 1)
      }
    }
  }, [_c('span', {
    staticClass: "carousel--arrow-wrap"
  }, [_c('cmp-icon', {
    staticClass: "carousel--arrow-icon",
    attrs: {
      "symbol": "chevron_left",
      "size": "large"
    }
  })], 1)]), _vm._v(" "), (_vm.showItemCountElement) ? _c('div', {
    staticClass: "carousel--counter",
    domProps: {
      "textContent": _vm._s(_vm.itemCount)
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "carousel--arrow carousel--arrow__next",
    attrs: {
      "type": "button",
      "disabled": _vm.state.idx + 1 > _vm.items.length - 1 ? true : null
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeIndex(_vm.state.idx + 1)
      }
    }
  }, [_c('span', {
    staticClass: "carousel--arrow-wrap"
  }, [_c('cmp-icon', {
    staticClass: "carousel--arrow-icon",
    attrs: {
      "symbol": "chevron_right",
      "size": "large"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showPaginationElement) ? _c('div', {
    staticClass: "carousel--pagination"
  }, [_c('ul', {
    staticClass: "u-reset carousel--bullets"
  }, _vm._l((_vm.items), function(item, itemIdx) {
    return _c('li', {
      staticClass: "carousel--bullet"
    }, [_c('button', {
      staticClass: "btn btn__pagination",
      attrs: {
        "data-active": _vm.state.idx === itemIdx
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestChange(itemIdx)
        }
      }
    })])
  }))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5580ab3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5580ab3c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/ui/carousel/index.vue
// module id = 547
// module chunks = 7